import { jsxs, jsx } from "react/jsx-runtime";
const IconPlaySvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "m12.267 7.4-8-4a.925.925 0 0 0-.6 0c-.2.133-.334.4-.334.6v8c0 .2.134.467.334.6.066.067.2.067.333.067s.2 0 .267-.067l8-4c.2-.133.4-.333.4-.6 0-.267-.134-.467-.4-.6Zm-7.6 3.533V5.067L10.533 8l-5.866 2.933Z" })
    ]
  }
);
export {
  IconPlaySvg
};
